export function createNotImplementedHandler() {
  return () => {
    throw new Error('Not implemented');
  };
}
